import en from "./locales/en.json";
import hi from "./locales/hi.json";
import mr from "./locales/mr.json";

const translations = {
  en,
  hi,
  mr,
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || key;
};

export const availableLanguages = Object.keys(translations);
